import dateFormat from 'dateformat';

export default function getOneMonthAgoDate(): string {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return dateFormat(date, 'yyyy-mm-dd');
}
